module.exports = __webpack_public_path__ + "img/upload_howitworks_success.84d6955b.svg";